<template>
  <div class="container">
    <a-tabs v-if="currPage === 1" :active-key="tabKey" @change="handleTabChange">
      <a-tab-pane v-for="item in tabPaneConfig" :key="item.key" :tab="item.tab">
        <TableList
          style="min-height: 80vh"
          :columns="item.columns"
          :tableData="item.tableData"
          :loading="item.loading"
          :scroll="{}"
          :pagination="tabPaneConfig[item.key - 1].pagination"
          @change="handleTableChange"
        >
          <div slot="queryArea" style="margin-bottom: 20px">
            <div class="flex-between">
              <div>
                <j-dict-select-tag
                  v-if="item.key == 1"
                  placeholder="请选择测评类型"
                  v-model="queryParam.type"
                  dictCode="evaluation_type"
                  style="width: 170px; margin-right: 15px"
                  allowClear
                />
                <a-input-search
                  v-if="item.key == 1"
                  v-model="queryParam.name"
                  placeholder="请输入评测名称"
                  style="width: 170px; margin-right: 15px"
                  @change="searchName"
                />
                <j-dict-select-tag
                  v-if="item.key == 2"
                  style="width: 170px; margin-right: 15px"
                  placeholder="请选择年级"
                  v-model="queryParam.gradeIds"
                  dictCode="school_grade,grade_name,id,0=delete_flag order by sort_order"
                  :isShowEmpty="false"
                  @select="resetClass"
                  @clear="resetClass"
                />
                <j-dict-select-tag
                  v-if="item.key == 2"
                  style="width: 170px; margin-right: 15px"
                  placeholder="请选择班级"
                  v-model="queryParam.classIds"
                  :dictCode="
                    'school_class,name,id,grade_id=' + (!queryParam.gradeIds ? -1 : queryParam.gradeIds)
                  "
                  :async="true"
                  :disabled="!queryParam.gradeIds"
                  :isShowEmpty="false"
                />
                <j-dict-select-tag
                  v-if="item.key == 2"
                  style="width: 170px; margin-right: 15px"
                  v-model="queryParam.status"
                  placeholder="请选择测评状态"
                  dictCode="evaluation_status"
                />
                <a-button type="primary" @click="queryTable">查询</a-button>
              </div>
              <div>
                <a-button
                  v-if="item.key == 1"
                  type="primary"
                  ghost
                  style="margin-left: 15px"
                  @click="createQuestion"
                >
                  添加心理量表
                </a-button>
                <a-button
                  v-if="item.key == 1"
                  type="primary"
                  ghost
                  @click="importQuesExcel"
                  style="margin-left: 15px"
                >
                  导入心理量表
                </a-button>
                <a-button
                  v-if="item.key == 2"
                  type="primary"
                  ghost
                  @click="createEvaluation"
                  style="margin-left: 15px"
                >
                  创建测评计划
                </a-button>
              </div>
            </div>
          </div>
          <template slot="status" slot-scope="{ record }">
            <div :style="{ color: ['', '#13B999', '#1783E8', '#EB3D2F'][record.status] }">
              <!-- {{ record.status === 0 ? '未开始' :  record.status === 1 ? '进行中' : record.status === 2 ? '已撤回' : '已结束' }}-->
              {{ getDictCodeData(record.status) }}
            </div>
          </template>
          <div slot="evaluationMethod" slot-scope="{ record }">
            {{ record.evaluationMethod === 1 ? '学校机房' : '自主测评' }}
          </div>
          <div slot="createByRow" slot-scope="{ record }">
            {{ record.createBy }}
          </div>
          <template slot="action" slot-scope="{ record }">
            <div v-if="item.key == 1" class="action-detail">
              <span
                v-if="userInfo().username === 'admin'"
                :style="{ opacity: record.status == 1 && 0.5 }"
                @click="editEvalua(record)"
              >
                编辑
              </span>
              <a-divider v-if="userInfo().username === 'admin'" type="vertical" />
              <a-popconfirm
                title="确定要删除该量表吗？"
                ok-text="是"
                cancel-text="否"
                @confirm="deleteScale(record)"
                @cancel="() => {}"
              >
                <span
                  v-if="userInfo().username === 'admin'"
                  :style="{ color: '#f81d22', opacity: record.status == 1 && 0.5 }"
                >
                  删除
                </span>
              </a-popconfirm>
              <a-divider type="vertical" v-if="userInfo().username === 'admin'" />
              <span @click="previewEval(record)">预览</span>
            </div>
            <div v-if="item.key == 2" class="action-detail">
              <span :class="{ forbidden: record.status != 0 }" @click="cancelEvaluation(record)">
                撤回测评
              </span>
              <a-divider type="vertical" />
              <span :class="{ forbidden: record.status != 0 }" @click="editPlan(record)">编辑</span>
              <a-divider v-if="userInfo().username === 'admin'" type="vertical" />
              <a-popconfirm
                title="确定要删除该测评吗？"
                ok-text="是"
                cancel-text="否"
                @confirm="deleteEvalua(record)"
                @cancel="() => {}"
              >
                <span v-if="userInfo().username === 'admin'" :style="{ color: '#f81d22' }">
                  删除
                </span>
              </a-popconfirm>
              <a-divider type="vertical" />
              <span @click="viewReport(record)">数据报告</span>
              <a-divider type="vertical" />
              <span :class="{ forbidden: record.status != 1 }" @click="copyText(record)">
                复制链接
              </span>
            </div>
          </template>
        </TableList>
      </a-tab-pane>
      <a-tab-pane v-for="item in tabPageConfig" :key="item.key" :tab="item.tab">
        <component :is="item.com" />
      </a-tab-pane>
    </a-tabs>
    <EvalPreview v-if="currPage == 2" :previewEvalData="previewEvalData" @back="currPage = 1" />
    <!-- 创建评测 -->
    <CreateEvaluation ref="createEvaluationRef" @changeTab="tabKey = 2" @refreshTable="loadData" />
    <CancleEvaluation ref="cancleEvaluationRef" @refreshTable="loadData" />
    <!-- 测评导入 -->
    <ImportQues ref="importQuesRef" @refreshTable="loadData" />
  </div>
</template>
<script>
import TableList from '@/components/chart/TableList'
import { deleteAction, getAction } from '@api/manage'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { getDictCodeData, simpleDebounce } from '@/utils/util'
import CreateEvaluation from './components/CreateEvaluation'
import CancleEvaluation from './components/CancleEvaluation'
import EvalPreview from '@/comUi/EvalPreview'
import MindAssessment from '@/views/school/mentalHealth/MindAssessment'
import CrisisIntervent from '@/views/school/mentalHealth/CrisisIntervent'
import ImportQues from './components/ImportQues'
import { TOPIC_RECORD } from '@/store/mutation-types'
import Vue from 'vue'
import store from '@/store'
import { mapGetters } from 'vuex'

const tablePagination = {
  current: 1,
  pageSize: 10,
  pageSizeOptions: ['10', '50', '100'],
  showTotal: (total, range) => {
    return range[0] + '-' + range[1] + ' 共' + total + '条'
  },
  showQuickJumper: true,
  showSizeChanger: true,
  total: 0,
  disableMixinCreated: true,
}

export default {
  name: 'MindEvaluation',
  mixins: [JeecgListMixin],
  components: {
    TableList,
    CreateEvaluation,
    CancleEvaluation,
    EvalPreview,
    ImportQues,
    MindAssessment,
    CrisisIntervent,
  },
  data() {
    return {
      tabKey: 1,
      currPage: 1,
      queryParam: {
        // type: 0,
        // name: '',
      },
      selectedRowKeys: [],
      previewEvalData: {},
      tabPageConfig:[
        {
          tab: '心理评估',
          key:3,
          com:"MindAssessment"
        },
        {
          tab: '危机干预',
          key:4,
          com:"CrisisIntervent"
        }
      ],
      tabPaneConfig: [
        {
          tab: '心理量表',
          key: 1,
          columns: [
            {
              title: '序号',
              dataIndex: 'index',
              align: 'center',
            },
            {
              title: '量表名称',
              dataIndex: 'name',
              align: 'center',
            },
            {
              title: '测评类型',
              dataIndex: 'type',
              align: 'center',
              customRender: (_, record) => {
                return record.type ? getDictCodeData('evaluation_type', record.type).text : ''
              },
            },
            {
              title: '题数',
              dataIndex: 'num',
              align: 'center',
            },
            {
              title: '用时（分）',
              dataIndex: 'time',
              align: 'center',
            },
            {
              title: '操作',
              dataIndex: 'action',
              align: 'center',
              scopedSlots: { customRender: 'action' },
            },
          ],
          tableData: [],
          loading: false,
          pagination: { ...tablePagination },
        },
        {
          tab: '心理测评',
          key: 2,
          columns: [
            {
              title: '序号',
              dataIndex: 'index',
              align: 'center',
            },
            {
              title: '评测名称',
              dataIndex: 'name',
              align: 'center',
            },
            {
              title: '状态',
              dataIndex: 'status',
              align: 'center',
              scopedSlots: { customRender: 'status' },
            },
            {
              title: '测评方式',
              dataIndex: 'evaluationMethod',
              align: 'center',
              scopedSlots: { customRender: 'evaluationMethod' },
            },
            {
              title: '创建人',
              scopedSlots: { customRender: 'createByRow' },
              align: 'center',
            },
            {
              title: '已完成人数',
              dataIndex: 'finishStudentNum',
              align: 'center',
            },
            {
              title: '未完成人数',
              dataIndex: 'createBy',
              align: 'center',
              customRender: (_, record) => {
                return record.planStudentNum - record.finishStudentNum
              },
            },
            {
              title: '创建时间',
              dataIndex: 'createTime',
              align: 'center',
            },
            {
              title: '操作',
              dataIndex: 'action',
              align: 'center',
              scopedSlots: { customRender: 'action' },
            },
          ],
          tableData: [],
          loading: false,
          pagination: { ...tablePagination },
        },
      ],
      url: {
        list: '',
        importExcelUrl: '',
        exportXlsUrl: '',
      },
      detailModalData: [],
      textToCopy:
        window.location.origin + '/#/school/mentalHealth/StudentAnswer/index',
      viewRecord: {},
    }
  },
  created() {
    console.log('用户信息：', store.getters.userInfo.username)
    this.viewRecord = this.$router.history.current.query
    if (this.viewRecord?.tabKey) {
      this.tabKey = Number(this.viewRecord.tabKey)
    }
    console.log('历史记录--', this.viewRecord)
    this.loadData()
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  methods: {
    ...mapGetters(['userInfo']),
    getDictCodeData(status) {
      return getDictCodeData('assessment_status', status).text || ''
    },
    handleTabChange(key) {
      this.tabKey = key
      if(key == 1 || key == 2){
        this.queryParam = {}
        this.detailModalData = []
        this.loadData()
      }
    },
    // 分页变化
    handleTableChange(page) {
      this.$set(this.tabPaneConfig[this.tabKey - 1], 'pagination', page)
      this.loadData()
    },
    onSelectChange(selectedRowKeys) {
      console.log('selectedRowKeys changed: ', selectedRowKeys)
      this.selectedRowKeys = selectedRowKeys
    },
    // 查询
    queryTable() {
      console.log('查询条件--', this.queryParam)
      this.$set(this.tabPaneConfig[this.tabKey - 1], 'pagination', { ...tablePagination })
      this.loadData()
    },
    // 创建量表
    createQuestion() {
      this.$router.push({ path: '/school/mentalHealth/QuestionnaireSystem', params: {} })
    },
    // 测评导入
    importQuesExcel() {
      this.$refs.importQuesRef.showModal()
    },
    searchName: simpleDebounce(function (event) {
      console.log('搜索条件--', event.target.value)
      const name = event.target.value
      this.getTableData({
        name,
      })
    }, 500),
    loadData() {
      let params = {
        pageNo: this.tabPaneConfig[this.tabKey - 1].pagination.current,
        pageSize: this.tabPaneConfig[this.tabKey - 1].pagination.pageSize,
        ...this.queryParam,
      }
      switch (this.tabKey) {
        case 1:
          this.$set(this.url, 'list', '/schoolEvaluation/list')
          params = { ...params }
          break
        case 2:
          this.$set(this.url, 'list', '/schoolEvaluationPlan/list')
          params = { ...params }
          break
      }
      this.getTableData(params)
      // this.queryParam = {}
    },
    getTableData(params) {
      this.$set(this.tabPaneConfig[this.tabKey - 1], 'loading', true)
      let dataKey = this.tabKey
      getAction(this.url.list, params)
        .then((res) => {
          console.log('获取列表数据--', res)
          if (res.success) {
            if(dataKey != this.tabKey){
              return
            }
            const tableData = res.result.records.length
              ? res.result.records.map((item, index) => ({
                  ...item,
                  index: index + 1,
                }))
              : []
            this.$set(this.tabPaneConfig[this.tabKey - 1], 'tableData', tableData)
            this.$set(this.tabPaneConfig[this.tabKey - 1].pagination, 'total', res.result.total)
          }
        })
        .finally(() => {
          this.$set(this.tabPaneConfig[this.tabKey - 1], 'loading', false)
        })
    },
    createEvaluation(data) {
      this.$refs.createEvaluationRef.showModal()
    },
    cancelEvaluation(data) {
      if (data.status != 0) return
      this.$refs.cancleEvaluationRef.showModal(data)
    },
    editEvalua(record) {
      if (record.status == 1) {
        this.$message.warning('该量表已被使用，不能被编辑')
        return
      }
      this.$router.push({
        path: `/school/mentalHealth/QuestionnaireSystem`,
        query: { id: record.id },
      })
    },
    editPlan(data) {
      if (data.status != 0) return
      this.$refs.createEvaluationRef.showModal(data)
    },
    deleteScale(record) {
      if (record.status == 1) {
        this.$message.warning('该量表已被使用，不能被删除')
        return
      }
      deleteAction('/schoolEvaluation/delete', { id: record.id }).then((res) => {
        if (res.success) {
          this.$message.success('删除成功')
          this.loadData()
        } else {
          this.$message.error('删除失败')
        }
      })
    },
    deleteEvalua(record) {
      deleteAction('/schoolEvaluationPlan/delete', { id: record.id }).then((res) => {
        if (res.success) {
          this.$message.success('删除成功')
          this.loadData()
        } else {
          this.$message.error('删除失败')
        }
      })
    },
    previewEval(record) {
      console.log('行记录：', record)
      this.previewEvalData = record
      this.currPage = 2
    },
    viewReport(record) {
      console.log('记录：', record)
      this.$router.push({
        path: '/school/mentalHealth/PlanDetails',
        query: {
          id: record.id,
          tag: 0,
          title: record.name,
          classIds: record.classIds,
          gradeIds: record.gradeIds,
          pagePath: '/school/mentalHealth/MindEvaluation',
          pageName: '评测计划',
          tabKey: 2,
        },
      })
    },
    copyText(record) {
      console.log('复制链接--', record)
      if (record.status != 1) return
      console.log('复制链接--', this.textToCopy)
      // 使用现代剪贴板API
      Vue.ls.set(TOPIC_RECORD, { queryRecord: record })
      navigator.clipboard
        .writeText(this.textToCopy)
        .then(() => {
          this.$message.success('复制链接成功')
        })
        .catch((err) => {
          this.$message.error('复制链接失败')
        })
    },
    //选择年级或则清除班级，重置班级
    resetClass() {
      this.$set(this.queryParam, 'classIds', undefined)
    },
  },
}
</script>
<style scoped lang="less">
.container {
  padding: 0px 20px;
  background-color: #fff;
}

.action-detail {
  color: #0077fa !important;
  cursor: pointer !important;

  .forbidden {
    pointer-events: none;
    cursor: default;
    color: #8bc1f3;
  }
}
</style>
